import { Component, Input } from '@angular/core';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import {
  ButtReplacementCustomDialogComponent,
  ButtReplacementCustomDialogData,
} from '@cutting/main/butt-replacement-custom-dialog/butt-replacement-custom-dialog.component';
import { CuttingPanel } from 'cloud-shared-lib';
import * as _ from 'lodash';

@Component({
  selector: 'cutting-butt-replacement-bottom-sheet',
  templateUrl: './butt-replacement-bottom-sheet.component.html',
  styleUrls: ['./butt-replacement-bottom-sheet.component.scss'],
  standalone: true,
  imports: [MatListModule, MatBottomSheetModule],
})
export class ButtReplacementBottomSheetComponent {
  @Input() matInMatBaseId = 0;
  @Input() materialThickness = 0;

  buttReplacementCustomDialogRef: MatDialogRef<ButtReplacementCustomDialogComponent>;

  panel: CuttingPanel[] = [];

  set panels(val: CuttingPanel[]) {
    this.panel = _.cloneDeep(val);
  }

  constructor(
    public bottomSheetRef: MatBottomSheetRef<ButtReplacementBottomSheetComponent>,
    public dialog: MatDialog
  ) {}

  deleteButts(): void {
    this.panel.forEach(item => {
      item.l1 = undefined;
      item.l2 = undefined;
      item.w1 = undefined;
      item.w2 = undefined;
    });

    this.bottomSheetRef.dismiss(this.panel);
  }

  openButtReplacementCustomDialog(): void {
    this.buttReplacementCustomDialogRef = this.dialog.open(ButtReplacementCustomDialogComponent, {
      panelClass: 'butt-replacement-custom-dialog',
      disableClose: false,
      width: '500px',
      data: {
        panels: this.panel,
        matInMatBaseId: this.matInMatBaseId,
        materialThickness: this.materialThickness,
      } as ButtReplacementCustomDialogData,
    });

    this.buttReplacementCustomDialogRef.afterClosed().subscribe((result: CuttingPanel[]) => {
      if (result) {
        this.panel = result;

        this.bottomSheetRef.dismiss(this.panel);
      }
      this.buttReplacementCustomDialogRef = null;
    });
  }
}
